export default __webpack_public_path__ + "static/b238e0594e38ff1756a311d8e39c1e42.png";